<div class="edit-exhibitor-multimedia">
  <h2>{{ 'EDIT_EXHIBITOR_MULTIMEDIA.TITLE' | translate }}</h2>

  <div class="section-container">
    <div class="edit-exhibitor-multimedia__header-container">
      <h3>{{ 'EDIT_EXHIBITOR_MULTIMEDIA.IMAGES_SUBTITLE' | translate }}</h3>
      <div class="image-wrap text-center pointer addFile">
        <label>
          <img class="pointer action-note" width="50" height="54"  src="assets/img/note_add.svg">
          <input type="file" id="image-file" accept="image/*" hidden (change)="imageFileChange($event)">
        </label>
      </div>

    </div>
    <p>{{ "EDIT_EXHIBITOR_MULTIMEDIA.IMAGES" | translate }}</p>
    <p>{{ "EDIT_EXHIBITOR_MULTIMEDIA.CATALOGUE_PLAN" | translate }} ({{ exhibitorData['images'].length }}/ {{ exhibitorData['imageProductLimit'] }}) .{{ "EDIT_EXHIBITOR_MULTIMEDIA.IMAGES_RECOMENDED_SIZE" | translate }}</p>
    <div class="edit-exhibitor-multimedia__images">
      <div class="edit-exhibitor-multimedia__image" *ngFor="let image of exhibitorData['images']">
        <img [src]="image.url" class="image" name="{{ 'image-' + image.id }}" />
        <img class="pointer remove-item-img" width="25" height="25"  src="assets/img/close_black.svg" (click)="removeImage(image)" >
      </div>
    </div>
  </div>

  <div class="section-container">
    <div class="edit-exhibitor-multimedia__header-container">
      <h3>{{ 'EDIT_EXHIBITOR_MULTIMEDIA.FILES_SUBTITLE' | translate }}</h3>
      <div class="image-wrap text-center pointer addFile">
        <label>
          <img class="pointer action-note" width="50" height="54"  src="assets/img/note_add.svg">
          <input type="file" id="file" accept="'.pdf, application/pdf, application/x-pdf'" hidden (change)="fileChange($event)">
        </label>
      </div>
    </div>
    <p>{{ "EDIT_EXHIBITOR_MULTIMEDIA.CATALOGUE_PLAN" | translate }} ({{ exhibitorData['files'].length }}/ {{ this.maxFileCount }}) .{{ "EDIT_EXHIBITOR_MULTIMEDIA.FILES_RECOMENDED_SIZE" | translate }}</p>
    <div class="edit-exhibitor-multimedia__files">
      <div class="edit-exhibitor-multimedia__file" *ngFor="let file of exhibitorData['files']">
        <a [href]="file.url" target="_blank" name="{{ 'file-' + file.id }}" >{{ file.url }}</a>
        <img class="pointer remove-item-file" width="25" height="25"  src="assets/img/close_black.svg" (click)="removeFile(file)" >
      </div>
    </div>
  </div>

  <div class="section-container">
    <h3>{{ 'EDIT_EXHIBITOR_MULTIMEDIA.VIDEO_SUBTITLE' | translate }}</h3>
    <div class="edit-exhibitor-multimedia__video">
      <p>{{ "EDIT_EXHIBITOR_MULTIMEDIA.VIDEO" | translate }}</p>
    </div>
    <form class="form-group">
      <input type="text" name="video" [(ngModel)]="exhibitorData['product']['videoUrl']" class="custom-form-control form-control">
    </form>
    <app-detail-video [projection]="exhibitorData['product']"></app-detail-video>
  </div>
</div>
